// src/auth.js
// Storage and token helpers.
// Tokens and user data default to localStorage (remember = true).
export const TOKEN_KEY = "app_tokens";
export const USER_KEY = "app_user";
export const REMEMBER_KEY = "remember_login"; // stores { username: "..." }

function getStorage(remember) {
  return remember ? localStorage : sessionStorage;
}

function clearOtherStorage(remember, key) {
  const other = remember ? sessionStorage : localStorage;
  other.removeItem(key);
}

export function saveTokens(tokens, remember = true) {
  if (!tokens || !tokens.access_token || !tokens.expires_in) {
    throw new Error("Invalid tokens object");
  }

  const payload = {
    access_token: tokens.access_token,
    refresh_token: tokens.refresh_token || null,
    token_type: tokens.token_type || "Bearer",
    expires_in: tokens.expires_in,
    obtained_at: Date.now(),
  };

  const storage = getStorage(remember);
  storage.setItem(TOKEN_KEY, JSON.stringify(payload));
  clearOtherStorage(remember, TOKEN_KEY);
}

export function loadTokens() {
  const raw = localStorage.getItem(TOKEN_KEY) || sessionStorage.getItem(TOKEN_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    clearTokens();
    return null;
  }
}

export function saveUser(userObj, remember = true) {
  if (!userObj || typeof userObj !== "object") {
    throw new Error("Invalid user object");
  }

  const storage = getStorage(remember);
  storage.setItem(USER_KEY, JSON.stringify(userObj));
  clearOtherStorage(remember, USER_KEY);
}

export function loadUser() {
  const raw = localStorage.getItem(USER_KEY) || sessionStorage.getItem(USER_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function clearTokens() {
  localStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  sessionStorage.removeItem(USER_KEY);
}

export function isTokenExpired(tokens) {
  if (!tokens?.obtained_at || !tokens?.expires_in) return true;
  const expiresAt = tokens.obtained_at + tokens.expires_in * 1000;
  return Date.now() >= expiresAt - 30_000; // 30s buffer
}

// ----------------- remember username helpers -----------------
export function saveRememberedUsername(username) {
  if (!username) {
    localStorage.removeItem(REMEMBER_KEY);
    return;
  }
  try {
    localStorage.setItem(REMEMBER_KEY, JSON.stringify({ username }));
  } catch {}
}

export function loadRememberedUsername() {
  try {
    const raw = localStorage.getItem(REMEMBER_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed?.username || null;
  } catch {
    return null;
  }
}

export function clearRememberedUsername() {
  try {
    localStorage.removeItem(REMEMBER_KEY);
  } catch {}
}
